import { CommonModule } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA, Type } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { VTableModule } from '@app/directives/_layout/v-table/v-table.module';
import { VisualisationsModule } from '@app/directives/_visualisations/visualisations.module';
import { CoreDirectivesModule } from '@directives/_core/_core.directives.module';
import { FormsDirectivesModule } from '@directives/_forms/_form.directives.module';
import { LayoutDirectivesModule } from '@directives/_layout/_layout.directives.module';
import { MapDirectivesModule } from '@directives/_map/_map.directives.module';
import { MiscDirectivesModule } from '@directives/_misc/_misc.directives.module';
import { ResourceFiltersDirectivesModule } from '@directives/_resourceFilters/_resourceFilters.directives.module';
import { TranslationDirectivesModule } from '@directives/_translations/_translations.directives.module';
import { VehicleDirectivesModule } from '@directives/_vehicle/_vehicle.directives.module';
import { VeriDirectivesModule } from '@directives/_veri/_veri.directives.module';
import { providerCreator } from '@services/_services.module';
import { StateParams } from '@uirouter/angularjs';
import { PipesModule } from 'src/app/_pipes/_pipes.module';
import { AccountSettingsManagerComponent } from './account-settings/account-settings-manager.component';
import { AccountSettingsSaveWarningComponent } from './account-settings/account-settings-save-warning/account-settings-save-warning.component';
import { AutoDownloadConfigurationComponent } from './cameras/camera-channels-editor/auto-download-configuration/auto-download-configuration.component';
import { AutoDownloadConfigurationEditorComponent } from './cameras/camera-channels-editor/auto-download-configuration/editor/auto-download-configuration-editor.component';
import { CameraChannelsEditorComponent } from './cameras/camera-channels-editor/camera-channels-editor.component';
import { ChannelThumbnailComponent } from './cameras/camera-channels-editor/channel-thumbnail/channel-thumbnail.component';
import { CameraVehiclesManagerComponent } from './cameras/camera-vehicles-manager/camera-vehicles-manager.component';
import { ContextualSpeedingByRoadComponent } from './contextual-speeding-settings-manager/contextual-speeding-by-road/contextual-speeding-by-road.component';
import { ContextualSpeedingByVehicleComponent } from './contextual-speeding-settings-manager/contextual-speeding-by-vehicle/contextual-speeding-by-vehicle.component';
import { ContextualSpeedingRoadEditorComponent } from './contextual-speeding-settings-manager/contextual-speeding-road-editor/contextual-speeding-road-editor.component';
import { ContextualSpeedingSettingsManagerComponent } from './contextual-speeding-settings-manager/contextual-speeding-settings-manager.component';
import { ContextualSpeedingVehicleEditorComponent } from './contextual-speeding-settings-manager/contextual-speeding-vehicle-editor/contextual-speeding-vehicle-editor.component';
import { DeviceProfileComparisonStatusLabelComponent } from './device-profiles-manager/device-profile-comparison-status-label/device-profile-comparison-status-label.component';
import { DeviceProfileEditorComponent } from './device-profiles-manager/device-profile-editor/device-profile-editor.component';
import { DeviceProfileVehiclePreviewComponent } from './device-profiles-manager/device-profile-vehicle-preview/device-profile-vehicle-preview.component';
import { DeviceProfileVehicleViewComponent } from './device-profiles-manager/device-profile-vehicle-view/device-profile-vehicle-view.component';
import { DeviceProfilesManagerComponent } from './device-profiles-manager/device-profiles-manager.component';
import { DrivingStyleAssociationsManagerComponent } from './driving-styles-manager/driving-style-associations-manager/driving-style-associations-manager.component';
import { DrivingStyleEditorComponent } from './driving-styles-manager/driving-style-editor/driving-style-editor.component';
import { DrivingStyleMetricEditorComponent } from './driving-styles-manager/driving-style-metric-editor/driving-style-metric-editor.component';
import { DrivingStyleMetricSelectorComponent } from './driving-styles-manager/driving-style-metric-selector/driving-style-metric-selector.component';
import { DrivingStyleMetricWeightingLabelComponent } from './driving-styles-manager/driving-style-metric-weighting-label/driving-style-metric-weighting-label.component';
import { DrivingStyleVehiclePreviewComponent } from './driving-styles-manager/driving-style-vehicle-preview/driving-style-vehicle-preview.component';
import { DrivingStylesManagerComponent } from './driving-styles-manager/driving-styles-manager.component';
import { GroupsModule } from './groups/groups.module';
import { SamlConfigurationComponent } from "./users/saml-configuration/saml-configuration.component";
import { UserEditorComponent } from './users/userEditor/user-editor.component';
import { TemperatureZonesComponent } from './vehicles/temperatureProbes/temperature-zones-edit/temperature-zones-edit.component';

const privateComponents: Type<any>[] = [
];

const publicComponents: Type<any>[] = [
    DrivingStylesManagerComponent,
    DrivingStyleEditorComponent,
    DrivingStyleAssociationsManagerComponent,
    DrivingStyleMetricEditorComponent,
    DrivingStyleMetricSelectorComponent,
    DrivingStyleMetricWeightingLabelComponent,
    DrivingStyleVehiclePreviewComponent,

    TemperatureZonesComponent,
    DeviceProfilesManagerComponent,
    DeviceProfileEditorComponent,
    DeviceProfileVehicleViewComponent,
    DeviceProfileVehiclePreviewComponent,
    DeviceProfileComparisonStatusLabelComponent,
    CameraChannelsEditorComponent,
    CameraVehiclesManagerComponent,
    UserEditorComponent,

    ChannelThumbnailComponent,

    AccountSettingsManagerComponent,
    AccountSettingsSaveWarningComponent,
    ContextualSpeedingSettingsManagerComponent,
    ContextualSpeedingByVehicleComponent,
    ContextualSpeedingByRoadComponent,
    ContextualSpeedingRoadEditorComponent,
    ContextualSpeedingVehicleEditorComponent,
    SamlConfigurationComponent,
    AutoDownloadConfigurationComponent,
    AutoDownloadConfigurationEditorComponent
];

@NgModule({
    imports: [
        CommonModule,
        VeriDirectivesModule,
        TranslationDirectivesModule,
        MiscDirectivesModule,
        ReactiveFormsModule,
        VTableModule,

        LayoutDirectivesModule,
        PipesModule,
        ResourceFiltersDirectivesModule,
        VehicleDirectivesModule,
        FormsDirectivesModule,
        CoreDirectivesModule,
        MapDirectivesModule,

        FormsModule,
        VisualisationsModule,
        GroupsModule
    ],
    entryComponents: [...publicComponents, ...privateComponents],
    declarations: [...publicComponents, ...privateComponents],
    exports: [...publicComponents],
    providers: [
        providerCreator(StateParams, "$stateParams")
    ],
    schemas: [NO_ERRORS_SCHEMA]
})
export class ResourceManagementModule {
    constructor() {}
}
